export function updatePagination() {
    if (!this.pagination) return;

    if (this.totalPages <= 1) {
        this.pagination.classList.add('hidden');
        return;
    }

    this.pagination.classList.remove('hidden');

    const start = (this.currentPage - 1) * this.perPage + 1;
    const end = Math.min(start + this.perPage - 1, this.totalCollections);

    if (this.paginationInfo) {
        this.paginationInfo.textContent = `Hiển thị ${start} - ${end} của ${this.totalCollections} collections`;
    }

    if (this.paginationCurrent) {
        this.paginationCurrent.textContent = this.currentPage;
    }

    if (this.paginationTotal) {
        this.paginationTotal.textContent = this.totalPages;
    }

    if (this.paginationPrev) {
        this.paginationPrev.disabled = this.currentPage <= 1;
    }

    if (this.paginationNext) {
        this.paginationNext.disabled = this.currentPage >= this.totalPages;
    }
}

export function previousPage() {
    if (this.currentPage > 1) {
        this.currentPage--;
        this.loadCollections();
    }
}

export function nextPage() {
    if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadCollections();
    }
}

export function resetToFirstPage() {
    this.currentPage = 1;
}
